import IcoMoon, { IconNames } from '@/components/IcoMoon'
import { UserPreference as UserPreferenceType } from '@/shared/api-generated-types'

interface Props extends UserPreferenceType {
  onClick: (id: string) => void
}

const UserPreference = (props: Props): JSX.Element => {
  return (
    <div
      className={`${
        props.isSelected ? 'border-[#d3eee1] bg-[#f4fbf7]' : 'bg-white'
      } flex gap-4 border mb-2 p-4 w-full md:flex-col md:items-center rounded-lg cursor-pointer min-w-[185px]`}
      onClick={() => props.onClick(props.id)}
    >
      {props.isSelected ? (
        <IcoMoon className="bg-green-600 rounded-full p-1" icon="check" color="white" size="32" />
      ) : (
        <IcoMoon icon={props.icon as IconNames} size="32" />
      )}
      <div>
        <div className="text-primary font-bold md:text-center">{props.name}</div>
        <div className="md:text-center">{props.description}</div>
      </div>
    </div>
  )
}

export default UserPreference
